import { memo } from 'react';
import PropTypes from 'prop-types';
import StructuredContent from '@nerdwallet/structured-content-core';
import {
  stringInputSpec,
  numberInputSpec,
  boolCheckboxSpec,
} from '../editing-configs';
import UniversalContainer, {
  universalContainerPropTypes,
} from '../../components/universal-container';
import styles from './instagram-player.module.scss';

// We are using memo to prevent re-rendering of the Player component
// when the parent component re-renders. The Instagram embed code breaks when
// we got too many re-renders.
const Player = memo(({ url, maxWidth, hideCaptions }) => (
  <StructuredContent>
    {{
      type: 'Instagram',
      version: '1.0.0',
      props: {
        url,
        maxWidth,
        hideCaptions,
      },
    }}
  </StructuredContent>
));

const InstagramPlayer = (props) => {
  const { instagramURL, maxWidth, hideCaptions, mediaContainer } = props;

  return (
    <UniversalContainer
      {...mediaContainer}
      width="100%"
      data-testid="InstagramPlayer"
    >
      <div className={styles.instagramEmbed}>
        <Player
          url={instagramURL}
          maxWidth={maxWidth}
          hideCaptions={hideCaptions}
        />
      </div>
    </UniversalContainer>
  );
};

Player.propTypes = {
  url: PropTypes.string.isRequired,
  maxWidth: PropTypes.number,
  hideCaptions: PropTypes.bool,
};

Player.defaultProps = {
  maxWidth: 650,
  hideCaptions: false,
};

InstagramPlayer.getEditingConfig = (_componentDocument, fieldName) => {
  const getInputName = (name) => {
    return `${fieldName?.split('.').at(-1)}.${name}`;
  };
  return [
    stringInputSpec(getInputName('instagramURL'), 'Instagram Video URL', {
      help: 'Provide here the full Instagram post or reel URL',
    }),
    numberInputSpec(getInputName('maxWidth'), 'Embed Max Width', {
      help: 'Maximum width of returned media. Must be between 320 and 658 px',
    }),
    boolCheckboxSpec(getInputName('hideCaptions'), 'Hide Captions', {
      help: 'If set to true, the embed code hides the caption.',
    }),
  ];
};

InstagramPlayer.displayName = 'Instagram Player';
InstagramPlayer.propTypes = {
  instagramURL: PropTypes.string,
  maxWidth: PropTypes.number,
  hideCaptions: PropTypes.bool,
  mediaContainer: universalContainerPropTypes,
};

InstagramPlayer.defaultProps = {
  maxWidth: 650,
  hideCaptions: false,
};

export default InstagramPlayer;
